import { type Node } from "prosemirror-model";
import { Transform } from "prosemirror-transform";

import { schema } from "@moment/prosemirror-schema";

/**
 * Transforms the provided doc to remove inclusive formatting marks
 * (em, strong, strike) from trailing whitespace in text nodes.
 *
 * This prevents serializing trailing whitespace to markdown, which
 * is technically invalid, and results in persisting formatting
 * characters into the actual hydrated document as plaintext.
 */
export function transformStripTrailingSpaceMarks(doc: Node) {
	const tr = new Transform(doc);
	doc.descendants((node, pos) => {
		if (node.type.name !== "text") {
			return true;
		}

		const text = node.text;
		if (!text) return true;
		const tailMatch = text.match(/\s+$/);
		if (tailMatch) {
			const tailStart = text.length - tailMatch[0].length;
			tr.removeMark(pos + tailStart, pos + text.length, schema.marks.em);
			tr.removeMark(pos + tailStart, pos + text.length, schema.marks.strong);
			tr.removeMark(pos + tailStart, pos + text.length, schema.marks.strike);
		}

		const leadMatch = text.match(/^\s+/);
		if (leadMatch) {
			const leadEnd = leadMatch.length;
			tr.removeMark(pos, pos + leadEnd, schema.marks.em);
			tr.removeMark(pos, pos + leadEnd, schema.marks.strong);
			tr.removeMark(pos, pos + leadEnd, schema.marks.strike);
		}
	});

	return tr.doc;
}
